var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"active":_vm.tooltip !== null,"label":_vm.$t(_vm.tooltip),"position":'is-' + _vm.tooltipPosition,"multilined":_vm.multilined}},[_c('button',{staticClass:"rounded-full w-8 h-8 btn p-0",class:{
      [`btn-${_vm.color}`]: true,
      [`text-${_vm.iconColor}`]: true,
    },attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[_c('b-icon',{attrs:{"icon":_vm.icon,"pack":_vm.iconPack,"size":"is-small"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }